import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import AdminLayout from '@/components/AdminLayout'
import CustomerLayout from '@/components/CustomerLayout'
import LoadingSpinner from '@/components/LoadingSpinner'
import Login from '@/pages/Login'
import CustomerRegister from '@/pages/CustomerRegister'
import Dashboard from '@/pages/Dashboard'
import CustomerDashboard from '@/pages/CustomerDashboard'
import Customers from '@/pages/Customers'
import CustomerDetail from '@/pages/CustomerDetail'
import NewCustomer from '@/pages/NewCustomer'
import Shipments from '@/pages/Shipments'
import CustomerShipments from '@/pages/CustomerShipments'
import CustomerShipmentDetail from '@/pages/CustomerShipmentDetail'
import CustomerNewShipment from '@/pages/CustomerNewShipment'
import NewShipment from '@/pages/NewShipment'
import ShipmentDetail from '@/pages/ShipmentDetail'
import Invoices from '@/pages/Invoices'
import CustomerInvoices from '@/pages/CustomerInvoices'
import CustomerInvoiceDetail from '@/pages/CustomerInvoiceDetail'
import NewInvoice from '@/pages/NewInvoice'
import InvoiceDetail from '@/pages/InvoiceDetail'
import Profile from '@/pages/Profile'
import UserManagement from '@/pages/UserManagement'
import LandingPage from '@/pages/LandingPage'

function App() {
  const AppRoutes = () => {
    const { user, loading, role } = useAuth()
    console.log('🔄 AppRoutes render - User:', user ? 'exists' : 'null', 'Role:', role, 'Loading:', loading);
    if (loading) {
      console.log('⏳ Showing loading spinner');
      return (
        <div className="flex justify-center items-center h-screen">
          <LoadingSpinner />
        </div>
      );
    }
    // Public routes
    if (!user) {
      console.log('🚫 No user, showing public routes');
      return (
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/customer-register" element={<CustomerRegister />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      );
    }
    // Role-based routing
    if (role === 'admin' || role === 'superadmin') {
      console.log('👨‍💼 Admin user, showing admin layout');
      return (
        <AdminLayout>
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/new" element={<NewCustomer />} />
            <Route path="/customers/:id" element={<CustomerDetail />} />
            <Route path="/shipments" element={<Shipments />} />
            <Route path="/shipments/new" element={<NewShipment />} />
            <Route path="/shipments/:id" element={<ShipmentDetail />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/invoices/new" element={<NewInvoice />} />
            <Route path="/invoices/:id" element={<InvoiceDetail />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </AdminLayout>
      );
    }
    if (role === 'customer') {
      console.log('👤 Customer user, showing customer layout');
      return (
        <CustomerLayout>
          <Routes>
            <Route path="/portal/dashboard" element={<CustomerDashboard />} />
            <Route path="/portal/shipments" element={<CustomerShipments />} />
            <Route path="/portal/shipments/new" element={<CustomerNewShipment />} />
            <Route path="/portal/shipments/:id" element={<CustomerShipmentDetail />} />
            <Route path="/portal/invoices" element={<CustomerInvoices />} />
            <Route path="/portal/invoices/:id" element={<CustomerInvoiceDetail />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="*" element={<Navigate to="/portal/dashboard" />} />
          </Routes>
        </CustomerLayout>
      );
    }
    // Fallback for users with no role or during role transition
    console.log('⚠️ User exists but no valid role, showing fallback');
    return (
      <div className="flex justify-center items-center h-screen">
        <p>You do not have the necessary permissions to view this page.</p>
      </div>
    );
  };
  return <AppRoutes />
}
export default App 